'use client';

import useTranslation from 'next-translate/useTranslation';
import { eqiPlusServices } from '@/config/cms/eqiPlusContent';
import { WidgetContainer } from '@/components/molecules/Widget/Container';
import { ServiceCard } from './Card';
export const ServiceListWidget = () => {
  const {
    t
  } = useTranslation('common');
  return <WidgetContainer containerId="service-list" title={t('widgets.ServiceListWidget.title')} data-sentry-element="WidgetContainer" data-sentry-component="ServiceListWidget" data-sentry-source-file="index.tsx">
      {eqiPlusServices.map((props, idx) => window.location.pathname === props.path ? null : <ServiceCard key={idx} {...props} />).filter(el => el !== null)}
    </WidgetContainer>;
};